import styled, { css } from 'styled-components';
import LottieComponent from 'react-lottie';

import { colors } from '../../styles/tokens';

interface containerProps {
  no_shadow: boolean;
}

export const Container = styled.div<containerProps>`
  position: fixed;
  inset: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 999;

  width: 100vw;
  height: 100vh;

  background-color: ${colors.surface}cc;

  ${props =>
    props.no_shadow &&
    css`
      background-color: transparent;
      transform: scale(0.4);
      position: relative;
      inset: auto;
      width: initial;
      height: initial;
    `}
`;

export const Lottie = styled(LottieComponent)`
  z-index: 100;
`;

export const LogoImg = styled.img<containerProps>`
  height: 120px;
  width: 120px;
  border-radius: 50%;

  box-shadow: 0px 0px 20px ${colors.primary}80;

  ${props =>
    props.no_shadow &&
    css`
      box-shadow: none;
    `}

  @media (max-width: 1199px) {
    /* width: 10%; */
  }

  @keyframes jump {
    0% {
      transform: translateY(0px);
    }
    60% {
      transform: translateY(-10px) scale(105%);
    }
    100% {
      transform: translateY(0px);
    }
  }

  animation: jump 1s infinite;
`;
